import { H2 } from "src/util/Typography";
import NumberRoll from "../../ui/NumberRoll";
import { Card } from "../../ui/Card";
import { handlegetTransactionStartDate, numberOrganizer } from "src/util/Util";
import { SelectAction } from "src/component/controllers/ClientAction";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { useEffect, useState } from "react";
import { ChartBar } from "../../ui/ChartBar";
import { useUser } from "src/context/UserContext";
import Loading from "../../ui/Loading";
import { useDateRange } from "src/context/DateRangeContext";
import NoDataFound from "../../NoDataFound";
import { StorageKey } from "src/util/Storage";
import { RenderIcon } from "src/assets/icons";

const typeOptions = ["Impressions"];
interface PublisherData {
  Publisher: string;
  Date: string;
  Revenue: number;
  Requests: number;
  Bids: number;
  Wins: number;
  Impressions: number;
  AdSlotRequests: number;
  FillRate: number;
  WTR: number;
  eCPM: number;
  AlkimiCommissionWin?: number;
  AlkimiCommissionImpr?: number;
  GrossRevenueWin?: number;
  GrossRevenueImpr?: number;
}

interface MediaTypeRevenue {
  mediaType: string;
  gross: number;
  commission: number;
  net: number;
}

interface MediaTypeRevenue {
  mediaType: string;
  gross: number;
  commission: number;
  net: number;
}

export const LatestPublisherDashboard = () => {
  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const { dashboardReportData } = useDateRange();
  const [totals, setTotals] = useState<{
    totalRevenue: number;
    totalImpressions: number;
    averageFillRate: number;
    averageECPM: number;
    totalGross: number;
    totalNet: number;
    commission: number;
    mediaTypeBreakdown: MediaTypeRevenue[];
    dateImpressions: Record<string, number>;
    dateRevenue: Record<string, number>;
  }>({
    totalRevenue: 0,
    totalImpressions: 0,
    averageFillRate: 0,
    averageECPM: 0,
    totalGross: 0,
    totalNet: 0,
    commission: 0,
    mediaTypeBreakdown: [],
    dateImpressions: {},
    dateRevenue: {},
  });
  const [totalData,setTotalData]=useState<any>([{}]);
  const customChartLabels = Object.keys(totals?.dateImpressions || {}).map(
    (key) => {
      const date = new Date(key);
      const month = date.toLocaleString("en-US", { month: "short" });
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    }
  );

  const textToJson = (csv: string): PublisherData[] => {
    const lines = csv.trim().split("\n");

    // Parse a CSV line respecting quotes
    const parseCSVLine = (line: string): string[] => {
      const result: string[] = [];
      let current = '';
      let inQuotes = false;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];

        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          result.push(current);
          current = '';
        } else {
          current += char;
        }
      }
      result.push(current);

      return result;
    };

    const headers = parseCSVLine(lines[0]);

    return lines.slice(1).map((line) => {
      const values = parseCSVLine(line);
      const obj: Partial<PublisherData> = {};

      headers.forEach((header, index) => {
        obj[header.trim()] = isNaN(Number(values[index]))
          ? values[index].trim()
          : Number(values[index]);
      });

      return obj as PublisherData;
    });
  };
  const calculateTotalsAndCombinations = (data: PublisherData[]) => {
    let totalRevenue = 0;
    let totalImpressions = 0;
    let totalFillRate = 0;
    let totalECPM = 0;
    let totalADResponse = 0;
    let totalADRequest = 0;
    let totalNet = 0;

    const dateImpressions: Record<string, number> = {};
    const dateRevenue: Record<string, number> = {};
    let totalCommission = 0;
    const mediaTypeMap: Record<string, { gross: number; net: number; commission: number }> = {};

    data?.forEach((item) => {
      const revenue = item?.['Revenue ($)'] || item?.Revenue || 0;
      const netRevenue = item?.['Net Revenue ($)'] || 0;
      const alkimiCommission = item?.['AlkimiCommission ($)'] || 0;

      totalRevenue += revenue;
      totalImpressions += item?.Impressions;
      totalFillRate += item?.FillRate||item?.['Fill Rate'] || item?.['Fill Rate (%)']|| item?.['Fill Rate (%) (Computed Metrics)'];
      totalECPM += item?.['eCPM (Computed Metrics)'] || item?.['eCPM ($) (Computed Metrics)'];
      totalADResponse += item?.["Ad-Response"];
      totalADRequest += item?.["Ad-Request"];
      totalNet += netRevenue;
      totalCommission += alkimiCommission;

      const mediaType = item?.['MediaType'] || item?.['Media Type'] || 'Other';
      if (!mediaTypeMap[mediaType]) {
        mediaTypeMap[mediaType] = { gross: 0, net: 0, commission: 0 };
      }
      mediaTypeMap[mediaType].gross += revenue;
      mediaTypeMap[mediaType].net += netRevenue;
      mediaTypeMap[mediaType].commission += alkimiCommission;

      const date = item?.Date?.split(" ")[0];
      dateImpressions[date] = (dateImpressions[date] || 0) + item.Impressions;
      dateRevenue[date] = (dateRevenue[date] || 0) + item?.Revenue || item?.['Revenue ($)'];
    });

    const averageFillRate = (totalADResponse/ totalADRequest)* 100;
    // const averageFillRate = totalFillRate / data.length;
    const averageECPM = (totalRevenue / totalImpressions)*1000;
    // const averageECPM = totalECPM / data.length;
    const totalGross = totalRevenue;
    const commission = totalCommission;

    const mediaTypeBreakdown: MediaTypeRevenue[] = Object.entries(mediaTypeMap).map(
      ([mediaType, values]) => ({
        mediaType,
        gross: values.gross,
        net: values.net,
        commission: values.commission,
      })
    );

    return {
      totalRevenue,
      totalImpressions,
      averageFillRate,
      averageECPM,
      totalGross,
      totalNet,
      commission,
      mediaTypeBreakdown,
      dateImpressions,
      dateRevenue,
    };
  };



  useEffect(() => {
    // initialLoad();
    // console.log('hello',localStorage.getItem(StorageKey.DisabledDate))
    if(!localStorage.getItem(StorageKey.DisabledDate)){
      handlegetTransactionStartDate(user?.publisherId)
    }
  }, []);
useEffect(()=>{
  if(dashboardReportData){
    let data = textToJson(dashboardReportData);
    setTotalData(data)
    const calculatedTotals = calculateTotalsAndCombinations(data);
    setTotals(calculatedTotals);
  }
},[dashboardReportData])

  const totalGrossAll = totals.mediaTypeBreakdown.reduce((sum, m) => sum + m.gross, 0) || 1;
  const totalCommissionAll = totals.mediaTypeBreakdown.reduce((sum, m) => sum + m.commission, 0) || 1;
  const totalNetAll = totals.mediaTypeBreakdown.reduce((sum, m) => sum + m.net, 0) || 1;

  return (
    <>
      {" "}
      <main>
        <div className="grid">
          <div className="sticky top-[96px] z-10 bg-[#0A0A0A] pt-6 pb-4">
            <H2 className="uppercase m-0">Dashboard</H2>
          </div>
          {/* <Card
            padding="large"
            className="flex flex-col text-center justify-center  my-4 px-[10px]"
          >
            <span className="text-[#A1A1A1] text-[14px] leading-[18.18px] font-normal font-popins mb-2">
              {" "}
              Select Time Period
            </span>
            <div className="flex flex-col sm:flex-row justify-center align-center sm:justify-center gap-4">
              <DateRangePicker
                setDateRange={setDateRange}
                onApply={handleApply}
                dateRange={rangeData }
                handleClearRange={handleClearRange}
                initialValues={true}
                disabledDate={localStorage.getItem(StorageKey.DisabledDate)}
              />
            </div>
          </Card> */}
          <div className="relative">
            {loading&& <Loading className="w-[100%] h-[100%] items-start pt-[90px] sm:pt-[250px] "/>}
          {totals?.totalRevenue || totals?.totalImpressions || totals?.averageECPM || totals?.averageFillRate || totalData?.length>0 ?<>

          <div className="grid gap-4 grid-cols-3 mb-4">
            <Card className="flex-1 flex flex-col font-popins group pt-[14px] pb-[14px] px-[10px] md:px-[20px] lg:px-[20px] sm:pt-[18px] md:pt-[18px] lg:pt-[18px] sm:pb-[23px] sm:px-[20px] md:pb-[23px] lg:pb-[23px] justify-between sm:gap-0 h-[120px]">
              <span className="text-[#D0D0D0] text-[12px] leading-[17.04px] sm:text-[14px] sm:leading-[19.88px] font-normal flex flex-col sm:flex-row gap-3 sm:gap-2">
                <RenderIcon type="openEyeIcon"/>
                <span>Gross</span>
              </span>
              <span className="text-[#FFFF] text-[18px] leading-[20.16px] font-semibold sm:text-[28px] md:text-right">
                <NumberRoll
                  number={Number(totals?.totalGross || 0)}
                  prefix="$"
                  decimals={2}
                  compact
                />
              </span>
            </Card>
            <Card className="flex-1 flex flex-col font-popins group pt-[14px] pb-[14px] px-[10px] md:px-[20px] lg:px-[20px] sm:pt-[18px] md:pt-[18px] lg:pt-[18px] sm:pb-[23px] sm:px-[20px] md:pb-[23px] lg:pb-[23px] justify-between sm:gap-0 h-[120px]">
              <span className="text-[#D0D0D0] text-[12px] leading-[17.04px] sm:text-[14px] sm:leading-[19.88px] font-normal flex flex-col sm:flex-row gap-3 sm:gap-2">
                <RenderIcon type="ecpmIcon"/>
                <span>Commission</span>
              </span>
              <span className="text-[#FFFF] text-[18px] leading-[20.16px] font-semibold sm:text-[28px] md:text-right">
                <NumberRoll
                  number={Number(totals?.commission || 0)}
                  prefix="$"
                  decimals={2}
                  compact
                />
              </span>
            </Card>
            <Card className="flex-1 flex flex-col font-popins group pt-[14px] pb-[14px] px-[10px] md:px-[20px] lg:px-[20px] sm:pt-[18px] md:pt-[18px] lg:pt-[18px] sm:pb-[23px] sm:px-[20px] md:pb-[23px] lg:pb-[23px] justify-between sm:gap-0 h-[120px]">
              <span className="text-[#D0D0D0] text-[12px] leading-[17.04px] sm:text-[14px] sm:leading-[19.88px] font-normal flex flex-col sm:flex-row gap-3 sm:gap-2">
                <RenderIcon type="ecpmIcon"/>
                <span>Net</span>
              </span>
              <span className="text-[#FFFF] text-[18px] leading-[20.16px] font-semibold sm:text-[28px] md:text-right">
                <NumberRoll
                  number={Number(totals?.totalNet || 0)}
                  prefix="$"
                  decimals={2}
                  compact
                />
              </span>
            </Card>
          </div>

          <div className="grid gap-4 md:grid-cols-1 lg:grid-cols-2">
            <Card className="p-[16px] sm:p-[24px]">
              <h3 className="text-[#D0D0D0] text-[16px] sm:text-[18px] font-semibold font-popins mb-4">
                Revenue by Media Type
              </h3>
              <div className="grid gap-4 grid-cols-2">
                {[{ dataKey: 'Banner', label: 'Display' }, { dataKey: 'Video', label: 'Video' }].map(({ dataKey, label }) => {
                  const media = totals.mediaTypeBreakdown.find((m) => m.mediaType === dataKey) || { mediaType: dataKey, gross: 0, commission: 0, net: 0 };
                  return (
                    <Card
                      key={dataKey}
                      className="flex flex-col font-popins p-[20px] sm:p-[24px] gap-[20px]"
                    >
                      <h4 className="text-[#FFFFFF] text-[18px] sm:text-[20px] font-semibold text-center">
                        {label}
                      </h4>

                      <div className="flex flex-col gap-[4px]">
                        <div className="flex justify-between items-center">
                          <span className="text-[#D0D0D0] text-[13px] sm:text-[14px] font-normal font-popins">
                            Gross Revenue
                          </span>
                          <span className="text-[#FFFFFF] text-[14px] sm:text-[16px] font-semibold font-popins">
                            <NumberRoll number={media.gross} prefix="$" decimals={2} compact />
                          </span>
                        </div>
                        <div className="w-full h-[6px] bg-[#3a3a3a] rounded-full overflow-hidden">
                          <div
                            className="h-full bg-[#D4C9A8] rounded-full transition-all duration-500"
                            style={{ width: `${(media.gross / totalGrossAll) * 100}%` }}
                          />
                        </div>
                      </div>

                      <div className="flex flex-col gap-[4px]">
                        <div className="flex justify-between items-center">
                          <span className="text-[#D0D0D0] text-[13px] sm:text-[14px] font-normal font-popins">
                            Commission
                          </span>
                          <span className="text-[#FFFFFF] text-[14px] sm:text-[16px] font-semibold font-popins">
                            <NumberRoll number={media.commission} prefix="$" decimals={2} compact />
                          </span>
                        </div>
                        <div className="w-full h-[6px] bg-[#3a3a3a] rounded-full overflow-hidden">
                          <div
                            className="h-full bg-[#D4C9A8] rounded-full transition-all duration-500"
                            style={{ width: `${(media.commission / totalCommissionAll) * 100}%` }}
                          />
                        </div>
                      </div>

                      <div className="flex flex-col gap-[4px]">
                        <div className="flex justify-between items-center">
                          <span className="text-[#D0D0D0] text-[13px] sm:text-[14px] font-normal font-popins">
                            Net Revenue
                          </span>
                          <span className="text-[#FFFFFF] text-[14px] sm:text-[16px] font-semibold font-popins">
                            <NumberRoll number={media.net} prefix="$" decimals={2} compact />
                          </span>
                        </div>
                        <div className="w-full h-[6px] bg-[#3a3a3a] rounded-full overflow-hidden">
                          <div
                            className="h-full bg-[#D4C9A8] rounded-full transition-all duration-500"
                            style={{ width: `${(media.net / totalNetAll) * 100}%` }}
                          />
                        </div>
                      </div>
                    </Card>
                  );
                })}
              </div>
            </Card>
            <div className="flex flex-row md:flex-col gap-4">
              <Card className="flex-1 flex flex-col font-popins group pt-[14px] pb-[14px] px-[10px] md:px-[20px] lg:px-[20px] sm:pt-[18px] md:pt-[18px] lg:pt-[18px] sm:pb-[23px] sm:px-[20px] md:pb-[23px] lg:pb-[23px] justify-between sm:gap-0 h-[120px] sm:h-[auto]">
                <span className="text-[#D0D0D0] text-[12px] leading-[17.04px] sm:text-[14px] sm:leading-[19.88px] font-normal flex flex-col sm:flex-row gap-3 sm:gap-2">
                  <RenderIcon type="openEyeIcon"/>
                  <span>Impressions</span>
                </span>
                <span className="text-[#FFFF] text-[18px] leading-[20.16px] font-semibold sm:text-[28px] md:text-right">
                  <NumberRoll
                    number={Number(totals?.totalImpressions||0)}
                    compact
                  />
                </span>
              </Card>
              <Card className="flex-1 flex flex-col font-popins group pt-[14px] pb-[14px] px-[10px] md:px-[20px] lg:px-[20px] sm:pt-[18px] md:pt-[18px] lg:pt-[18px] sm:pb-[23px] sm:px-[20px] md:pb-[23px] lg:pb-[23px] justify-between sm:gap-0 h-[120px] sm:h-[auto]">
                <span className="text-[#D0D0D0] text-[12px] leading-[17.04px] sm:text-[14px] sm:leading-[19.88px] font-normal flex flex-col sm:flex-row gap-3 sm:gap-2">
                  <RenderIcon type="filrateIcon"/>
                  <div className="flex flex-row">
                    Fill rate
                    <span className="text-[#A1A1A1]"> (%)</span>
                  </div>
                </span>
                <span className="text-[#FFFF] text-[18px] leading-[20.16px] font-semibold sm:text-[28px] md:text-right">
                  <NumberRoll
                    number={Number(totals?.averageFillRate || 0)}
                    suffix="%"
                    decimals={2}
                    compact
                  />
                </span>
              </Card>
              <Card className="flex-1 flex flex-col font-popins group pt-[14px] pb-[14px] px-[10px] md:px-[20px] lg:px-[20px] sm:pt-[18px] md:pt-[18px] lg:pt-[18px] sm:pb-[23px] sm:px-[20px] md:pb-[23px] lg:pb-[23px] justify-between sm:gap-0 h-[120px] sm:h-[auto]">
                <span className="text-[#D0D0D0] text-[12px] leading-[17.04px] sm:text-[14px] sm:leading-[19.88px] font-normal flex flex-col sm:flex-row gap-3 sm:gap-2">
                  <RenderIcon type="ecpmIcon"/>
                  eCPM
                  <span className="text-[#A1A1A1] hidden sm:block"> ($)</span>
                </span>
                <span className="text-[#FFFF] text-[18px] leading-[20.16px] font-semibold sm:text-[28px] md:text-right">
                  <NumberRoll
                    number={Number(totals?.averageECPM||0)}
                    decimals={2}
                    prefix="$"
                    compact
                  />
                </span>
              </Card>
            </div>
          </div>

          <section className="mt-8 mb-[60px]">
            {totals?.dateImpressions && (
              <Card className="p-[12px] sm:p-[14px]">
                <div className="flex items-center justify-between mb-2">
                  <SelectAction url-variable-key="type" value={typeOptions[0]}>
                    <SelectTrigger className="w-max px-0 text-[13px]  leading-[18.2px] font-normal font-popins sm:text-[16px]  sm:leading-[22.4px] bg-transparent border-none">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="w-[100%] font-popins text-[14px]">
                      {typeOptions.map((option) => (
                        <SelectItem key={option} value={option} className="text-[13px] sm:text-[14px] font-popins">
                          {`${option}`}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </SelectAction>
                  <h2 className="flex items-center gap-[5px] sm:gap-[9px]">
                    <span className="text-[#A1A1A1] font-normal text-[12px] leading-[17.04px] sm:text-[14px] sm:leading-[19.88px] font-popins">
                      Total:{" "}
                    </span>
                    <span className="text-[#FFFFFF] font-medium text-[16px] leading-[22.4px] sm:font-semibold sm:text-[28px] sm:leading-[42px] font-popins">
                      {numberOrganizer.format(totals?.totalImpressions||0)}
                    </span>
                  </h2>
                </div>

                <ChartBar
                  className="col-span-2 lg:col-span-3"
                  tooltipLabel={typeOptions[0]}
                  chartDataFromSource={totals?.dateImpressions}
                  customLabels={customChartLabels}
                />
              </Card>
            )}
          </section>
          </>:<><NoDataFound/></>}
          </div>
        </div>
      </main>
    </>
  );
};
